// Lightweight crypto helpers.
// PINs are hashed at rest in localStorage so casual inspection
// (DevTools, backups, sync payloads) cannot read them in the clear.
// PINs are 4 digits so a hash is not a strong guarantee, but it
// removes trivial plaintext leakage without breaking offline login.

const SALT = "cafe-breizh:v1";

export async function hashPin(pin) {
  const value = String(pin ?? "");
  if (!value) return "";
  const data = new TextEncoder().encode(`${SALT}:${value}`);
  const buf = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
